import { PieChart as MuiPieChart } from '@mui/x-charts/PieChart';

import { PieChartProps } from './types';
import { Container } from './styles';

export function PieChart({ title, data, ...props }: PieChartProps) {
  return (
    <Container>
      {title && <strong>{title}</strong>}

      <MuiPieChart
        series={[
          {
            data,
            highlightScope: { fade: 'global', highlight: 'item' },
            faded: { innerRadius: 30, additionalRadius: -30, color: 'gray' },
          }
        ]}
        {...props}
      />
   </Container>
  )
}
